import React from "react";
import { Navigate } from "react-router-dom";
import {
  getAccessCondition,
  getCompanyDetails,
  getUserDetails,
} from "../utils/auth";

const PrivateRoute = ({ element, roles, module, requiredAccess }) => {
  const user = getUserDetails();
  const company = getCompanyDetails();
  // console.log(company.length, "companty");
  const accessCategory = getAccessCondition() || [];
  const accessDetails = accessCategory.access_details;
  if (!user) return <Navigate to="/" />;

  const { role } = user;

  if (isCompanyEmpty(role, company)) {
    return <Navigate to="/company" />;
  }
  if (!isRoleAuthorized(role, roles)) {
    return <Navigate to="/Unauthorized" />;
  }

  // if (isCompanyEmpty(role, company)) {
  //   return <Navigate to="/company" />;
  // }

  if (
    role === "other_user" &&
    module &&
    requiredAccess &&
    !hasModuleAccess(accessDetails, module, requiredAccess)
  ) {
    return <Navigate to="/Unauthorized" />;
  }
  return element;
};

const isRoleAuthorized = (role, roles) => {
  return !roles || roles.includes(role);
};

const isCompanyEmpty = (role, company) => {
  if (role !== "admin") return false;

  return (
    !company ||
    (Array.isArray(company) && company.length === 0) ||
    (typeof company === "object" && Object.keys(company).length === 0)
  );
};

const hasModuleAccess = (accessDetails, module, requiredAccess) => {
  return (
    accessDetails?.[module] && accessDetails[module].includes(requiredAccess)
  );
};

export default PrivateRoute;
